const defaultClassnames = "inline-block";

export { defaultClassnames };
